<div
  class="input-text-atom flex w-full rounded-3xl border border-neutral-600 focus-within:border-primary-600 focus-within:ring-2 focus-within:ring-primary-600"
>
  @if (!displayedValue && iconLeft) {
    <div
      class="rounded-l-3xl"
      [class.bg-neutral-100]="!fieldBackgroundColor"
      [style.backgroundColor]="
        fieldBackgroundColor ? (fieldBackgroundColor | contentBuilderColor) : null
      "
    >
      <i
        class="icon {{ iconLeft }} m-2 mr-0 cursor-pointer p-2"
        [class.text-neutral-600]="!fieldIconColor"
        [style.color]="fieldIconColor ? (fieldIconColor | contentBuilderColor) : null"
        (click)="iconClick.emit()"
      ></i>
    </div>
  }
  <input
    class="min-w-0 flex-1 border-0 overflow-ellipsis py-3.5 leading-5 outline-none ring-0 focus:border-0 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0
        {{ iconLeft ? 'rounded-r-3xl' : 'rounded-l-3xl rounded-r-not pl-4' }}"
    [class.pr-4]="!!currency"
    [class.text-right]="!!currency"
    [class.bg-neutral-100]="!fieldBackgroundColor"
    [class.text-neutral-800]="!fieldTextColor"
    [style.backgroundColor]="
      fieldBackgroundColor ? (fieldBackgroundColor | contentBuilderColor) : null
    "
    [style.color]="fieldTextColor ? (fieldTextColor | contentBuilderColor) : null"
    [style.--ipt-placeholder]="
      fieldPlaceholderColor ? (fieldPlaceholderColor | contentBuilderColor) : null
    "
    [type]="isNumberOnly ? 'number' : 'text'"
    [placeholder]="label"
    [value]="displayedValue ? displayedValue : ''"
    #addressSearchInput
    appAutoFocus
    (input)="onInputChange(addressSearchInput.value)"
    (keydown)="isNumberOnly ? numberOnly($event) : null"
  />
  @if (cross && displayedValue) {
    <div
      [class.bg-neutral-100]="!fieldBackgroundColor"
      [style.backgroundColor]="
        fieldBackgroundColor ? (fieldBackgroundColor | contentBuilderColor) : null
      "
      [class.rounded-r-3xl]="!buttonLabel"
      [class.neg-2]="isNative"
    >
      <i
        class="icon icon-cross m-2 cursor-pointer p-2 text-xs"
        [class.text-neutral-500]="!fieldIconColor"
        [style.color]="fieldIconColor ? (fieldIconColor | contentBuilderColor) : null"
        (click)="clearValue()"
      ></i>
    </div>
  }
  @if (!value && iconRight) {
    <div
      class="flex items-center rounded-r-3xl"
      [class.bg-neutral-100]="!fieldBackgroundColor"
      [style.backgroundColor]="
        fieldBackgroundColor ? (fieldBackgroundColor | contentBuilderColor) : null
      "
    >
      @if (!onAction) {
        <i
          class="icon {{ iconRight }} m-2 cursor-pointer p-2"
          [class.text-neutral-500]="!fieldIconColor"
          [style.color]="fieldIconColor ? (fieldIconColor | contentBuilderColor) : null"
          (click)="iconClick.emit(); triggerAction()"
        ></i>
      }
      @if (onAction) {
        <img
          src="assets/images/spinner.svg"
          alt=""
          class="mr-2 p-2"
        />
      }
    </div>
  }
  @if (currency) {
    <div
      class="flex items-center rounded-r-3xl"
      [class.bg-neutral-100]="!fieldBackgroundColor"
      [style.backgroundColor]="
        fieldBackgroundColor ? (fieldBackgroundColor | contentBuilderColor) : null
      "
    >
      <span
        class="m-2 cursor-pointer p-2"
        [class.text-neutral-500]="!fieldIconColor"
        [style.color]="fieldIconColor ? (fieldIconColor | contentBuilderColor) : null"
        >{{ currency }}</span
      >
    </div>
  }
  @if (buttonLabel && displayedValue) {
    <span
      class="cursor-pointer rounded-r-3xl bg-primary-600 p-3.5 pl-5.5 font-base text-base font-bold text-neutral-50"
      (click)="buttonClick.emit()"
    >
      {{ buttonLabel }}
    </span>
  }
</div>
